import lodash from 'lodash'
import { useTranslate } from 'ra-core'
import { FC, useEffect, useMemo } from 'react'
import { NumberInput, SelectInput } from 'react-admin'
import { useForm, useFormState } from 'react-final-form'

interface PropTypes {
  source: string
}

const QUANTITY_CHOICES = [
  { id: 0, name: 'Is smaller than', filter: 'has_system_smaller_than' },
  { id: 1, name: 'Is larger than', filter: 'has_system_larger_than' },
]

const SystemSize: FC<PropTypes> = ({ source }) => {
  const translate = useTranslate()
  const form = useForm()
  const formValues = useFormState().values
  const filterField = useMemo(() => lodash.get(formValues, `${source}.fields`), [formValues, source])
  const translatedChoices = useMemo(
    () => QUANTITY_CHOICES.map((c) => ({ ...c, name: translate(c.name) })),
    [translate]
  )

  useEffect(() => {
    let newValue = {}
    if (filterField?.conditional !== undefined && filterField?.quantity) {
      const selected = QUANTITY_CHOICES.find((x) => x.id === filterField.conditional)
      if (selected) newValue[selected.filter] = filterField?.quantity
    }
    form.change(`${source}.value`, newValue)
  }, [filterField, source, form])

  return (
    <>
      <SelectInput
        choices={translatedChoices}
        label={false}
        source={`${source}.fields.conditional`}
        variant="outlined"
        margin={'none'}
        style={{ minWidth: '100px' }}
      />
      <NumberInput label={false} source={`${source}.fields.quantity`} variant="outlined" margin={'none'} />
    </>
  )
}

export default SystemSize

